import loadSessionModule from './modules/Session.module';
import loadAuthenticationModule from './modules/Authentication.module';
const loadRegistrationCompactModule = () => ({
    hasRouter: true,
    modules: [loadSessionModule(), loadAuthenticationModule()],
});
export default loadRegistrationCompactModule;
